module.exports = __webpack_public_path__ + "img/Temperature.c7d463f7.png";